import { withBase, withoutHost } from "ufo";

/**
 * Get the full URL for a public asset, considering the CDN URL if configured.
 *
 * @param path - The path to the asset, relative to the public folder.
 */
export function usePublicAssetUrl(path: string) {
  const { app } = useRuntimeConfig();
  return withoutHost(withBase(path, app.cdnURL));
}
